import { StatsOverlay as Class } from './StatsOverlay';
export const StatsOverlay = Class.getInstance();
